import { fetchWithAuth } from '@shared/utils/auth';
import { backendUrl } from '@shared/constants/urls/appUrls';

//------------------------------------------------------------------------------
//                        Загрузить изображение на сервер
//------------------------------------------------------------------------------
export async function loadImageToServer(file){
  const url = `${backendUrl}/api/comments/image-upload/`;
  const formData = new FormData();
  formData.append('image', file);
  const options = {
    method: 'POST',
    body: formData,
  };
  try {
    const response = await fetchWithAuth(url, options);
    if (!response.ok) {
      throw new Error(`Сетевая ошибка при загрузке изображения на сервер: HTTP error! Status: ${ response.status }`);
    }
    return await response.json();
  } catch (error) {
    console.error('Программная ошибка загрузки изображения: Error fetching get comments list:', error);
    throw error;
  }
}
//xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx
